module.exports = __webpack_public_path__ + "static/media/homem_r2_c5.d5d47522.jpg";